import request from "@/api/request";

export function login(payload) {
  return request({
    url: "/api/auth/user/login",
    method: "post",
    data: payload,
  });
}

export function logout() {
  return request({
    url: "/api/auth/user/logout",
    method: "get",
  });
}

export function wxLogin(code, state) {
  return request({
    url: "/api/auth/wx/login",
    method: "get",
    params: {
      code,
      state,
    },
  });
}

export function paramConfig() {
  return request({
    url: "/api/sys/config/all",
    method: "get",
  });
}

export function validateToken() {
  return request({
    url: "/api/validate",
    method: "post",
  });
}

export function refreshToken(refreshTokenStr) {
  let formData = new FormData();
  formData.set("grant_type", "refresh_token");
  formData.set("refresh_token", refreshTokenStr);
  return request({
    url: "/oauth/access_token",
    method: "post",
    data: formData,
  });
}

export function getNextId(group, regulation, noLength, noResetType) {
  const encodedRegulation = encodeURIComponent(regulation);
  return request({
    url: `/TCustomIdentity/getNextId?group=${group}&regulation=${encodedRegulation}&noLength=${noLength}&noResetType=${noResetType}`,
    method: "get",
  });
}

export function getDicData(type) {
  return request({
    url: `/dicData/getByType?typeCode=${type}`,
    method: "get",
  });
}

/**
 * 查询多个类型
 * @param types 逗号分割 例如 a,b,c
 * @returns {*}
 */
export function getDicDataList(types) {
  return request({
    url: `/dicData/getByTypes?typeCodes=${types}`,
    method: "get",
  });
}

export function unblock(id) {
  return request({
    url: `/riskBanList/unblock`,
    method: "post",
    data: { id },
  });
}
